<template>
  <div>
    <h1 class="page-header">
      {{ $t('addministration.employee_feature.employee_profile') }}
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row">
            <div class="col-sm-12 col-lg-6 col-md-6">
              <div class="form-group row m-b-t-15">
                <label class="col-md-5 form-col-label control-label">
                  {{ $t('addministration.employee_feature.name_kh') }}
                </label>
                <div class="col-md-7">
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('name_kh') }"
                    v-model="model.name_kh"
                    ref="name_kh"
                    :placeholder="
                      $t(
                        'addministration.employee_feature.enter_employee_name_kh'
                      )
                    "
                  />
                  <div class="invalid-feedback" v-if="errors.has('name_kh')">
                    {{ errors.first('name_kh') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-5 form-col-label control-label">
                  {{ $t('addministration.employee_feature.name_en') }}
                  <span class="text-danger">*</span></label
                >
                <div class="col-md-7">
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('name_en') }"
                    v-model="model.name_en"
                    ref="name_en"
                    :placeholder="
                      $t(
                        'addministration.employee_feature.enter_employee_name_en'
                      )
                    "
                  />
                  <div class="invalid-feedback" v-if="errors.has('name_en')">
                    {{ errors.first('name_en') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-5 form-col-label control-label">
                  {{ $t('addministration.employee_feature.division') }}
                  <span class="text-danger">*</span></label
                >
                <div class="col-md-7">
                  <div class="input-group">
                    <select
                      v-model.number="model.division_id"
                      type="text"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('division_id') }"
                    >
                      <option value="" disabled selected style="display: none;">
                        --{{
                          $t('addministration.employee_feature.select')
                        }}--</option
                      >
                      <option
                        v-for="(division, index) in divisions"
                        :key="index"
                        :value="division.division_id"
                      >
                        {{ division.division_name_en }}
                      </option>
                    </select>
                    <div class="input-group-addon">
                      <router-link
                        class="text-info"
                        :to="{
                          name: 'division'
                        }"
                        v-tooltip="
                          $t('addministration.employee_feature.add_division')
                        "
                      >
                        <i class="fas fa-plus"></i>
                      </router-link>
                    </div>
                  </div>
                  <div class="validate">
                    {{ errors.first('division_id') }}
                  </div>
                </div>
              </div>
              <div class="form-group row m-b-t-15">
                <label class="col-md-5 form-col-label control-label">
                  {{ $t('addministration.employee_feature.department') }}
                  <span class="text-danger">*</span></label
                >
                <div class="col-md-7">
                  <div class="input-group">
                    <select
                      v-model.number="model.department_id"
                      type="text"
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('department_id') }"
                    >
                      <option value="" disabled selected style="display: none;">
                        --{{
                          $t('addministration.employee_feature.select')
                        }}--</option
                      >
                      <option
                        v-for="(department, index) in departments"
                        :key="index"
                        :value="department.department_id"
                      >
                        {{ department.department_name_en }}
                      </option>
                    </select>
                    <div class="input-group-addon">
                      <router-link
                        class="text-info"
                        :to="{
                          name: 'department'
                        }"
                        v-tooltip="
                          $t('addministration.employee_feature.add_department')
                        "
                      >
                        <i class="fas fa-plus"></i>
                      </router-link>
                    </div>
                  </div>
                  <div class="validate">
                    {{ errors.first('department_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group m-b-15">
                <label class="col-md-5 col-form-label">
                  {{ $t('addministration.employee_feature.description') }}
                </label>
                <div class="col-md-7">
                  <textarea
                    v-model="model.description"
                    class="form-control"
                    :class="{
                      'is-invalid': errors.has('description')
                    }"
                    rows="3"
                    :placeholder="
                      $t('addministration.employee_feature.enter_description')
                    "
                  ></textarea>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('description')"
                  >
                    {{ errors.first('description') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="row  text-right">
            <div class="col-lg-12">
              <ts-button
                color="primary"
                :waiting="save_add_new"
                @click="saveAddNew"
              >
                {{ $t('addministration.employee_feature.save_add_new') }}
              </ts-button>
              <ts-button
                class="ml-2"
                color="primary"
                :waiting="saving"
                @click="save"
              >
                {{ $t('addministration.employee_feature.save') }}
              </ts-button>

              <ts-button
                class="ml-2"
                @click="$router.push({ name: 'employee-profile' })"
              >
                {{ $t('addministration.employee_feature.cancel') }}
              </ts-button>
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'employee-profile-create',
  data() {
    return {
      model: {
        name_kh: '',
        name_en: '',
        description: '',
        division_id: '',
        department_id: ''
      },
      saving: false,
      save_add_new: false,
      errors: new Errors()
    }
  },
  mounted() {
    this.$refs.name_kh.focus()
  },
  computed: {
    ...mapState('employeeProfile', ['divisions', 'departments'])
  },
  methods: {
    async saveAddNew() {
      this.save_add_new = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'employeeProfile/store',
          Object.assign({}, this.model)
        )

        this.clearForm()
        this.$toasted.success(response.message)
        this.$refs.name_kh.focus()
        this.save_add_new = false
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
        this.save_add_new = false
      }
    },
    save() {
      this.saving = true
      this.errors = new Errors()
      this.$store
        .dispatch('employeeProfile/store', Object.assign({}, this.model))
        .then(respons => {
          this.$toasted.success(respons.message)
          this.$router.push({ name: 'employee-profile' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.saving = false
        })
    },

    clearForm() {
      this.model.name_kh = ''
      this.model.name_en = ''
      this.model.description = ''
      this.model.division_id = ''
      this.model.department_id = ''
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('employeeProfile/SET_DIVISIONS', [])
    this.$store.commit('employeeProfile/SET_DEPARTMENTS', [])
    next()
  }
}
</script>
